import * as yup from "yup";

export const signinStep2Schema = yup.object().shape({
  code: yup
    .string()
    .required("The field is required.")
    .min(6, "Code must have 6 digits.")
    .max(6, "Code must have 6 digits."),
});
